import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-3">
      <ol className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
        <li>
          <Link
            to="/"
            className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-700 font-medium' : ''}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}